import { render, staticRenderFns } from "./AppFileDropzone.vue?vue&type=template&id=cf1475e6&scoped=true"
import script from "./AppFileDropzone.vue?vue&type=script&lang=ts"
export * from "./AppFileDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1475e6",
  null
  
)

export default component.exports